import React from "react";
import { ArrowUpRight, ShieldCheck, Clock3, User } from "lucide-react";
import Reveal from "./Reveal";
import { APPLY_URL } from "../../data/mock";

export default function ApplySection() {
  return (
    <section id="apply" className="relative py-28 md:py-40 border-b hairline">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-[1fr_1.1fr] gap-14 items-start">
        <div>
          <div className="flex items-center gap-3 text-[var(--text-muted)] mb-8">
            <span className="h-px w-8 bg-[var(--line-2)]"></span>
            <span className="font-mono text-[10px] uppercase tracking-[0.3em]">— Start Here —</span>
          </div>
          <Reveal>
            <h2 className="font-display text-[54px] md:text-[86px] leading-[0.98] tracking-[-0.03em]">
              Apply to<br /> the <span className="italic-serif text-[var(--ember-3)]">brotherhood</span>.
            </h2>
          </Reveal>
        </div>
        <Reveal delay={150} className="md:pt-12">
          <p className="text-[var(--text-muted)] text-[18px] leading-[1.7] max-w-[560px]">
            Tell me a little about you. I'll personally read your answers and reply within 48 hours.
          </p>

          <a href={APPLY_URL} target="_blank" rel="noreferrer" className="btn-ember mt-10">Begin the Application <ArrowUpRight size={16}/></a>

          <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 border-t hairline pt-8">
            <div className="flex items-center gap-3"><User size={16} className="text-[var(--ember-2)]"/><span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--text-muted)]">Reviewed by Coach Colin</span></div>
            <div className="flex items-center gap-3"><Clock3 size={16} className="text-[var(--ember-2)]"/><span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--text-muted)]">48-hour response</span></div>
            <div className="flex items-center gap-3"><ShieldCheck size={16} className="text-[var(--ember-2)]"/><span className="font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--text-muted)]">100% confidential</span></div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
